module.exports = __webpack_public_path__ + "img/mrsnewssyllables.6c0de25e.png";